import * as S from "./Buttons.style";

interface ButtonProps {
  type: "button" | "submit" | "reset" | undefined;
  size:
    | "headerIcon"
    | "headerTextIcon"
    | "headerText"
    | "more"
    | "sm"
    | "md"
    | "lg"
    | "join"
    | "form"
    | "faqIcon"
    | "responsive";
  width?: string | undefined;
  layout: "solid" | "outline" | "text";
  color: "primary100" | "bright100" | "white100" | "black60";
  icon?: React.ReactElement;
  label?: string;
  onClick?: any;
  tabIndex?: number;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const Buttons = (props: ButtonProps) => {
  return (
    <S.Buttons
      type={props.type}
      $size={props.size}
      $width={props.width}
      $layout={props.layout}
      $color={props.color}
      tabIndex={props.tabIndex}
      onClick={props.onClick}
      disabled={props.disabled}
    >
      {props.icon && props.icon}
      {props.label && props.label}
      {props.children && props.children}
    </S.Buttons>
  );
};
